import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

interface BillingEmptyStateProps {
  action?: ReactNode;
  dataTestId: string;
  description: string;
  icon: ReactNode;
  title: string;
}

export default function BillingEmptyState({
  action,
  dataTestId,
  description,
  icon,
  title,
}: BillingEmptyStateProps) {
  return (
    <Box
      data-test-id={dataTestId}
      sx={(theme) => ({
        alignItems: 'center',
        backgroundColor: theme.semantic.surfaceRaised,
        border: `1px solid ${theme.brandV2.colors.treadGray7}`,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        px: 3,
        py: 6,
        textAlign: 'center',
      })}
    >
      <Box
        sx={(theme) => ({
          alignItems: 'center',
          backgroundColor: theme.brandV2.colors.treadGray9,
          border: `1px solid ${theme.brandV2.colors.treadGray7}`,
          borderRadius: 2,
          color: theme.brandV2.colors.treadGray3,
          display: 'flex',
          height: 44,
          justifyContent: 'center',
          width: 44,
        })}
      >
        {icon}
      </Box>
      <Typography sx={{ fontSize: 15, fontWeight: 600, mt: 1 }}>{title}</Typography>
      <Typography
        sx={(theme) => ({
          color: theme.semantic.textSecondary,
          fontSize: 13,
          maxWidth: '52ch',
        })}
      >
        {description}
      </Typography>
      {action ? <Box sx={{ mt: 1 }}>{action}</Box> : null}
    </Box>
  );
}
